import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth, homeFor } from "@/context/AuthContext";
import { Logo } from "@/components/opl/Common";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.name}`);
      nav(homeFor(u));
    } catch (e2) {
      setError(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden grain">
        <img src="/hero.jpg" alt="Floodlit cricket stadium" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-[#050B14]/60 to-[#050B14]/20" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="eyebrow">Oneiros Premier League</p>
          <h1 className="text-5xl font-black mt-3 leading-[1.05]">The auction floor<br /><span className="gold-text">awaits your paddle.</span></h1>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 rise" data-testid="login-form">
          <Link to="/"><Logo size="lg" /></Link>
          <div>
            <h2 className="text-3xl font-extrabold">Sign in</h2>
            <p className="text-sm text-slate-400 mt-1">Accounts are issued by the OPL organizers.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="h-11 bg-[#0B1323]" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="h-11 bg-[#0B1323]" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
          <button disabled={busy} className="w-full h-11 gold-bg rounded-full font-bold flex items-center justify-center gap-2 hover:brightness-110 transition-[filter] disabled:opacity-60" data-testid="login-submit-btn">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
          <p className="text-xs text-slate-500">Forgot your password? Contact the auction admin to reset it.</p>
        </form>
      </div>
    </div>
  );
}
